import { ReactNode, useMemo, useState } from "react";
import { newUuid } from "../utils/uuid";
import { get } from "lodash";
import styles from "./DropContainer.module.css";
import { classNames } from "../utils/classNames";

export function DropContainer({
  className,
  children,
  disabled,
  onActivate,
  onDeactivate,
  onDrop,
}: {
  className?: string;
  children: ReactNode | ((params: { active: boolean }) => ReactNode);
  disabled?: boolean;
  onActivate?: () => void;
  onDeactivate?: () => void;
  onDrop?: (files: File[]) => void;
}) {
  const id = useMemo(() => newUuid(), []);
  const [active, setActive] = useState(false);

  return (
    <div
      id={id}
      className={classNames(className, active && styles.dragActive)}
      onDragOver={(event) => {
        event.preventDefault();
        if (!disabled) {
          setActive(true);
          onActivate?.();
        }
      }}
      onDragLeave={(event) => {
        event.preventDefault();
        if (active && get(event.target, "id") === id) {
          setActive(false);
          onDeactivate?.();
        }
      }}
      onDrop={(event) => {
        event.preventDefault();
        if (!active) {
          return;
        }
        const files = Array.from(event.dataTransfer.files);
        if (files.length) {
          setActive(false);
          onDrop?.(files);
          onDeactivate?.();
        } else {
          setActive(false);
          onDeactivate?.();
        }
      }}
    >
      {typeof children === "function" ? children({ active }) : children}
    </div>
  );
}
